import { Box, Collapse, IconButton, Paper, Typography } from "@mui/material"
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useState } from "react"

import { SourceChangeHistoryTable } from "./components/SourceChangeHistoryTable"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert.tsx"
import { useGetSourceChangeHistory } from "@/screens/Products/components/SourceChanges/hooks/useGetSourceChangeHistory"

interface SourceChangeHistoryPanelProps {
  productId: number
}

export const SourceChangeHistoryPanel: FC<SourceChangeHistoryPanelProps> = ({ productId }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  const { sourceChangeGroups, isFetching } = useGetSourceChangeHistory(productId)

  return (
    <Paper className='border border-gray-400 p-6' elevation={0} data-testid='source-change.history-container'>
      <Box className='flex items-center justify-between'>
        <Typography variant='h6' data-testid='source-change.history-container.title'>
          Source Change History
        </Typography>
        <IconButton
          onClick={() => setIsExpanded((prev) => !prev)}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? "collapse" : "expand"}
          data-testid='source-change.history-container.toggle-button'
        >
          {isExpanded ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
        </IconButton>
      </Box>
      <Collapse in={isExpanded}>
        <Box className='pt-4'>
          {!isFetching && sourceChangeGroups.length === 0 ? (
            <InformationMissingAlert
              title='No source changes recorded'
              data-testid='no-groups-alert'
            ></InformationMissingAlert>
          ) : (
            <SourceChangeHistoryTable data={sourceChangeGroups} loading={isFetching} />
          )}
        </Box>
      </Collapse>
    </Paper>
  )
}
